import { Type } from 'class-transformer';
import { IsNumber, IsOptional, Max, Min } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { PagedRequest, PagedResponse } from '../request';
import { DEFAULT_ADMIN_PER_PAGE_MAX } from '../../const/pagination';
import type { SortableRequest, Sorters } from '../sortable';
import type { FilterableValue } from '../filterable';
import { DateISOString } from '../../types';
import { ClientType } from '../client/clientType';
import { CareerId } from '../../const/catalog/career';
import { DealRejectionReasonType, DealStatus } from '../deal';
import { ToBoolean } from '../../utils/validation/decorator/toBoolean';
import { ProcessingViewModel } from './viewModel.dto';
import { DealProcessingStatus } from './const';

type SortableFields = 'createdAt' | 'processed';

export class ProcessingListResponse implements PagedResponse<ProcessingViewModel> {
  items: ProcessingViewModel[];
  totalCount: number;
}

export class ProcessingListRequest implements PagedRequest, SortableRequest {
  @Type(() => Number)
  @IsOptional()
  @IsNumber()
  @Min(1)
  @ApiProperty({
    description: 'The number of page',
    example: 1,
    required: false,
  })
  page?: number;

  @Type(() => Number)
  @IsOptional()
  @IsNumber()
  @Max(DEFAULT_ADMIN_PER_PAGE_MAX)
  @ApiProperty({
    description: 'The number of items per page',
    example: 10,
  })
  pagination?: number;

  @ApiProperty()
  @IsOptional()
  dealStatus?: FilterableValue<DealStatus>;

  @ApiProperty()
  @IsOptional()
  processingStatus?: FilterableValue<DealProcessingStatus>;

  @ApiProperty()
  @IsOptional()
  createdAt?: FilterableValue<DateISOString>;

  @ApiProperty()
  @IsOptional()
  type?: FilterableValue<ClientType>;

  @ApiProperty()
  @IsOptional()
  vacancyId?: FilterableValue<number>;

  @ApiProperty()
  @IsOptional()
  cityId?: FilterableValue<number>;

  @ApiProperty()
  @IsOptional()
  feedbacksCount?: FilterableValue<number>;

  @ApiProperty()
  @IsOptional()
  careerId?: FilterableValue<CareerId>;

  @ApiProperty()
  @IsOptional()
  phoneOrEmail?: FilterableValue<string>;

  @ApiProperty()
  @IsOptional()
  rejectionReason?: FilterableValue<DealRejectionReasonType>;

  @ApiProperty()
  @IsOptional()
  sorters?: Sorters<SortableFields>;
}
